import script from "./mainError.vue?vue&type=script&setup=true&lang=js"
export * from "./mainError.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__